import Vue from 'vue'
import axios from 'axios'
//import helpers from '../../helpers'

Vue.use(axios)

const state = {
  records: []
}

const getters = {
  getPackages: state => state.records
}

const actions = {
  // fetch active packages
  async fetchPackages ({ commit }) {
    commit('clearLastError')
    if (process.env.VUE_APP_API_PATH) {
      try {
        const resp = await axios.get(
          process.env.VUE_APP_API_PATH + 'ajax/package/all'
        )
        if (resp && resp.data) {
          commit('updatePackages', resp.data.dataSet.packages)
        }
      } catch (error) {
        commit('setLastError', 'Error while loading data')
        console.log(error)
      }
    }
  }
}

const mutations = {
  updatePackages: (state, payload) => (state.records = payload)
}

export default {
  state,
  getters,
  actions,
  mutations
}
